<!-- START Top Navbar -->
<nav class="navbar topnavbar" role="navigation" aria-label="Top Navigation Bar">
  <!-- Add H1 for Level 1 Heading -->
  <h1 class="sr-only" id="site-title">Dashboard</h1>

  <!-- Mobile Layout -->
    <div
      class="d-flex d-md-none w-100 justify-content-between align-items-center px-3 py-2 bg-primary text-white"
      role="region"
      aria-labelledby="site-title"
      aria-label="Mobile Topbar"
    >
      <!-- Menu Toggle -->
      <a
        class="nav-link text-white"
        role="button"
        tabindex="0"
        (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()"
        (keydown.enter)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()"
        (keydown.space)="$event.preventDefault(); settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()"
        aria-label="Toggle Menu"
      >
        <em class="fas fa-bars" aria-hidden="true"></em>
      </a>

    <!-- Logo -->
    <a class="navbar-brand mx-auto" href="#/" aria-label="Homepage">
      <div class="brand-logo d-flex align-items-center">
        <img class="logo" src="/assets/img/logo.png" alt="Company logo" />
        <img class="solimarket ms-2" src="/assets/img/solimarket.png" alt="SoliMarket logo" />
      </div>
    </a>

    <!-- Logout -->
    <a
      class="nav-link text-white"
      role="button"
      tabindex="0"
      (click)="logout()"
      (keydown.enter)="logout()"
      (keydown.space)="$event.preventDefault(); logout()"
      title="Logout"
      aria-label="Log out of your account"
    >
      <em class="bi bi-box-arrow-in-left" aria-hidden="true"></em>
    </a>
  </div>

  <!-- Desktop/Tablet Layout -->
  <div
    class="d-none d-md-flex w-100 align-items-center justify-content-between px-3"
    role="region"
    aria-labelledby="site-title"
    aria-label="Desktop Topbar"
  >
    <!-- Sidebar Toggle -->
    <ul class="navbar-nav flex-row" aria-label="Sidebar controls">
      <li class="nav-item">
        <a
          class="nav-link"
          role="button"
          tabindex="0"
          trigger-resize
          (click)="toggleCollapsedSideabar()"
          (keydown.enter)="toggleCollapsedSideabar()"
          (keydown.space)="$event.preventDefault(); toggleCollapsedSideabar()"
          *ngIf="!isCollapsedText()"
          aria-label="Toggle Sidebar"
        >
          <em class="fas fa-bars" aria-hidden="true"></em>
        </a>
      </li>
    </ul>

    <!-- Logo Section -->
    <div class="navbar-header mx-auto">
      <a class="navbar-brand" href="#/" aria-label="Homepage">
        <ng-container *ngIf="!isCollapsedText(); else collapsedLogo">
          <div class="brand-logo d-flex align-items-center">
            <img class="logo" src="/assets/img/logo.png" alt="Company logo" />
            <img class="solimarket ms-2" src="/assets/img/solimarket.png" alt="SoliMarket logo" />
          </div>
        </ng-container>
        <ng-template #collapsedLogo>
          <div class="brand-logo-collapsed">
            <img src="/assets/img/logo.png" alt="Collapsed version of company logo" />
          </div>
        </ng-template>
      </a>
    </div>

    <!-- Balance Section -->
    <div class="flex-grow-1 d-flex justify-content-center">
      <ul
        class="navbar-nav flex-row"
        *ngIf="issuingEntity && user.isInRole('AgencyUser') && benefits?.length"
        aria-label="User Benefits Section"
      >
        <li
          class="nav-item brand-logo-collapsed"
          *ngFor="let item of benefits; let i = index"
          aria-label="Benefit Balance Information"
        >
          <span *ngIf="item.active">
            <span *ngIf="i > 0" class="mx-2" aria-hidden="true">|</span>
            {{ item.benefitName }} Balance: $
            {{ item.fundsAvailable | number : "1.0-2" }}
          </span>
        </li>
      </ul>
    </div>

    <!-- Right Section: Agency + Profile + Logout -->
    <ul class="navbar-nav flex-row ms-auto" aria-label="User Actions">
      <li class="nav-item d-none d-md-block">
        <a
          *ngIf="issuingEntity && user.issuingEntites.length > 1 && user.isInRole('AgencyUser')"
          class="nav-link"
          role="button"
          tabindex="0"
          (click)="changeIssuingEntity()"
          (keydown.enter)="changeIssuingEntity()"
          (keydown.space)="$event.preventDefault(); changeIssuingEntity()"
          title="Change Agency"
          aria-label="Change Issuing Agency"
        >
          <span class="entity">{{ issuingEntity.name }}</span>
          <em class="bi bi-arrow-left-right" aria-hidden="true"></em>
        </a>
        <span *ngIf="user.issuingEntites.length === 1" class="nav-link" aria-label="Current Agency">
          {{ user.issuingEntites[0].name }}
        </span>
      </li>
      <li class="nav-item d-none d-md-block">
        <a
          class="nav-link"
          [routerLink]="'/users/profile'"
          title="Profile"
          aria-label="Go to User Profile"
        >
          <em class="bi bi-person" aria-hidden="true"></em>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link text-white"
          role="button"
          tabindex="0"
          (click)="logout()"
          title="Logout"
          aria-label="Log out of your account"
        >
          <em class="bi bi-box-arrow-in-left" aria-hidden="true"></em>
        </a>
      </li>
    </ul>
  </div>
</nav>
<!-- END Top Navbar -->

<!-- Modal Template for Selecting Issuing Entity -->
<ng-template #selectIssuingEntity let-c="close" let-d="dismiss">
  <div
    class="modal-header"
    role="dialog"
    aria-labelledby="select-agency-dialog-title"
    aria-describedby="select-agency-dialog-description"
    aria-modal="true"
  >
    <h4 class="modal-title" id="select-agency-dialog-title">Select Agency</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="d('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" id="select-agency-dialog-description">
    <app-select-issuing-entity
      (refresh)="onRefresh($event)"
      aria-label="Select an Issuing Entity"
    ></app-select-issuing-entity>
  </div>
</ng-template>